import { render } from "./search.vue?vue&type=template&id=8f6c1eb4"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./search.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script